// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1RJ-v","ranges":"BmiRanges_ranges__2poIZ"};